import { BlurEvent, ClickEvent, DataSourceExecutionEvent, DataSourceMode, Layout, ScreenStack, Snackbar } from "@mcleod/components";
import { Api, HorizontalAlignment, Navigation } from "@mcleod/core";
import { AutogenLayoutAssignMarketPlan } from "@mcleod/crm/src/autogen/AutogenLayoutAssignMarketPlan";
import { CommonDialogs } from "@mcleod/common";
import { ModelMarketPlan } from "./models/ModelMarketPlan";

export class AssignMarketPlan extends AutogenLayoutAssignMarketPlan {

    private opportunityID: string = null;

    async sourceCustomerAfterExecution(event: DataSourceExecutionEvent) {
        if (this.mainDataSource.activeRow && !this.mainDataSource.activeRow.isNull("mark_plan_id")) {
            const marketPlan = await new ModelMarketPlan().searchSingle({ id: this.mainDataSource.activeRow.get("mark_plan_id") });
            this.mainDataSource.activeRow.setLookupModelData("mark_plan_id", marketPlan);
            this.mainDataSource.displayDataInBoundComponent(this.textboxCustomerMarkPlanId);
            this.mainDataSource.activeRow.set("start_date", new Date());
            this.textboxContact.required = !this.mainDataSource.activeRow.isNull("mark_plan_id") && this.opportunityID != null;
        }
    }

    textboxMarkPlanIdOnBlur(event: BlurEvent) {
        this.textboxContact.required = !this.mainDataSource.activeRow.isNull("mark_plan_id") && this.opportunityID != null;
    }


    textboxCustomerMarkPlanIdBeforeLookupModelSearch(event) {
        event.filter.type_of = "C";
    }

    static showModal(customerId: string, opportunityId?: string, onSuccess?: () => void) {
        const layout = Layout.getLayout("lme/crm/AssignMarketPlan") as AssignMarketPlan;
        layout.opportunityID = opportunityId;
        layout.addLayoutDataLoadListener(async event => {
            const request = await layout.mainDataSource.createBlankRow();
            if (opportunityId) {
                layout.textboxCustomerStartDate.enabled = false;
                await layout.sourceOpportunity.search({id: opportunityId}, null, "lme/crm/Opportunity");
                const opportunity = layout.sourceOpportunity.activeRow;
                if (opportunity) {
                    const today = new Date();
                    const effDate = opportunity.getDate("effective_date", null);
                    request.setValueAndLookupModelData("mark_plan_id", opportunity.get("mark_plan_id", null),
                        {id:opportunity.get("mark_plan_id", null), descr: opportunity.get("market_plan.descr", null)}
                    );
                    request.setValueAndLookupModelData("contact_name", opportunity.get("primary_contact", null),
                        {name: opportunity.get("primary_contact", null)}
                    );
                    request.setValues({
                        "start_date": (today > effDate) ? today : effDate,
                        "opportunity_id": opportunityId
                    });
                }
            } else {
                await layout.sourceProspect.search({id: customerId}, null, "lme/crm/Prospect");
                const prospect = layout.sourceProspect.activeRow;
                layout.textboxContact.visible = false;
                if (prospect) {
                    request.setValueAndLookupModelData("mark_plan_id", prospect.get("mark_plan_id", null),
                        {id:prospect.get("mark_plan_id", null), descr: prospect.get("market_plan.descr", null)}
                    );
                    request.setValues({
                        "start_date": prospect.getDate("start_date", null),
                        "payee_id": customerId
                    });
                }
            }
            layout.mainDataSource.setRowsAndMode(DataSourceMode.ADD, [request]);
            layout.textboxContact.addBeforeLookupModelSearchListener(event => {
                if (customerId == null) {
                    event.preventDefault();
                } else {
                    event.filter.parent_row_id = customerId;
                    event.filter.parent_row_type = "C";
                }
            });
        });

        CommonDialogs.showYesNo(layout, "Assign Market Plan", {
            width: 400,
            panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" },
            panelContentProps: { align: HorizontalAlignment.CENTER },
            noButtonCaption: "Cancel",
            yesButtonProps: { caption: "Assign", backgroundColor: 'primary', color: 'default.reverse', onClick: async (event: ClickEvent) => {
                if (!layout.validateSimple()) {
                    event.preventDefault();
                    return;
                }
                const progressSnackbar = Snackbar.showDownloadSnackbar("Action In Progress", "Assigning Market Plan...", {
                    targetPanel: ScreenStack.getPreviousSnackbarTarget(), persist: true
                });
                Api.post("lme/crm/assign-market-plan", layout.activeRow)
                .then(() => {
                    if (onSuccess) {
                        onSuccess();
                    }
                })
                .catch((err) => Snackbar.showWarningSnackbar("Failed to assign market plan: " + err.messages[0]))
                .finally(() => progressSnackbar.dismiss());
            }}
        });
    }
}
